import React from 'react';
import { View, ActivityIndicator, StyleSheet, Text, Image } from 'react-native';

const logoImage = require('../../assets/obzidn-logo.png');

const LoadingScreen = () => {
  return (
    <View style={styles.container}>
      <Image
        source={logoImage}
        style={styles.logoImage}
        resizeMode="contain"
      />
      <Text style={styles.brandName}>OBZIDN</Text>
      <Text style={styles.subtitle}>Driver</Text>
      <ActivityIndicator size="large" color="#C9A84C" style={styles.loader} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#0a0a0a',
    overflow: 'visible',
  },
  logoImage: {
    width: 100,
    height: 100,
    minWidth: 100,
    minHeight: 100,
    marginBottom: 16,
  },
  brandName: {
    fontSize: 28,
    fontWeight: '700',
    color: '#C9A84C',
    letterSpacing: 6,
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 16,
    color: '#cccccc',
    marginBottom: 30,
  },
  loader: {
    marginBottom: 20,
  },
});

export default LoadingScreen;
